<template>
    <main class="page-phototheque-detail">
        <div class="container">
            <h1 class="page-phototheque-detail__breadcrumbs">
                <a :href="photothequeUrl">Photothèque</a>
                <img class="page-phototheque-detail__breadcrumbs-separator" src="@/assets/images/chevron.svg" alt=">" />
                <span v-html="categoryName"></span>
            </h1>

            <div class="row">
                <slot name="cards"></slot>
            </div>

            <nav class="row">
                <paginator class="col-12">
                    <slot name="pagination"></slot>
                </paginator>
            </nav>
        </div>
    </main>
</template>

<script>
    import Paginator from '@/components/Paginator';
    import LayoutTitleBar from '@/components/layout/TitleBar';

    export default {
        name: 'PhotothequeCategory',

        components: { Paginator, LayoutTitleBar },

        props: {
            photothequeUrl: { type: String, required: true },
            categoryName:   { type: String, required: true },
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_placeholders';

    .page-phototheque-detail {

        &__breadcrumbs {
            @extend %font-OpenSans-light;

            display:     flex;
            align-items: center;
            flex-wrap:   wrap;

            margin:      3rem 0;

            font-size:   2.5rem;

            &, & > * {
                color: $gray-500;
            }

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                font-size: 3.5rem;
            }
        }

        &__column {
            display:     flex;
            align-items: stretch;
        }

        &__breadcrumbs-separator {
            // Toutes les dimenrsions sont en em.
            // Ça permet n'avoir que la taille de police du parent à changer en desktop.
            position:  relative;
            top:       0.12em;
            display:   block;

            width:     0.64em;
            height:    auto;

            margin:    0 0.4em;

            transform: rotate(-90deg);
        }
    }
</style>
